import juice from '../../assets/muvtech/Muvdata/powerbank/juice.png';
import minlight from '../../assets/muvtech/Muvdata/powerbank/minlight.png';
import pocket from '../../assets/muvtech/Muvdata/powerbank/pocket.png';
import pocketpro from '../../assets/muvtech/Muvdata/powerbank/pocketpro.png';
import slim from '../../assets/muvtech/Muvdata/powerbank/slim.png';
import slimpro from '../../assets/muvtech/Muvdata/powerbank/slimpro.png';
import tank from '../../assets/muvtech/Muvdata/powerbank/Tank.png';
import ultraslim from '../../assets/muvtech/Muvdata/powerbank/ultraslim.png';

const powerbankData = [
  {
    id: 1,
    type: 'powerbank',
    title: 'Slim',
    compatibleModels: 'All Smartphones',
    price: 4999,
    specs: ['10000mAh', 'MagSafe', 'PD 20W', 'Metal + Silicone'],
    image: [slim],
  },
  {
    id: 2,
    type: 'powerbank',
    title: 'SlimPro',
    compatibleModels: 'All Smartphones',
    price: 5999,
    specs: ['10000mAh', 'MagSafe + Watch Charging', 'PD 20W'],
    image: [slimpro],
  },
  {
    id: 3,
    type: 'powerbank',
    title: 'Minlite',
    compatibleModels: 'All Smartphones',
    price: 3999,
    specs: ['5000mAh', 'PD 20W', 'Compact'],
    image: [minlight],
  },
  {
    id: 4,
    type: 'powerbank',
    title: 'Ultraslim',
    compatibleModels: 'All Smartphones',
    price: 3999,
    specs: ['5000mAh', 'Slim body', '10.5mm thin'],
    image: [ultraslim],
  },
  {
    id: 5,
    type: 'powerbank',
    title: 'Tank',
    compatibleModels: 'All Smartphones',
    price: 6999,
    specs: ['20000mAh', 'PD 20W', 'Rugged design'],
    image: [tank],
  },
  {
    id: 6,
    type: 'powerbank',
    title: 'Pocket',
    compatibleModels: 'All Smartphones',
    price: 2999,
    specs: ['5000mAh', 'ABS', 'Lightweight'],
    image: [pocket],
  },
  {
    id: 7,
    type: 'powerbank',
    title: 'PocketPro',
    compatibleModels: 'All Smartphones',
    price: 3999,
    specs: ['10000mAh', 'ABS', 'Slim'],
    image: [pocketpro],
  },
  {
    id: 8,
    type: 'powerbank',
    title: 'Juice',
    compatibleModels: 'All Smartphones',
    price: 2999,
    specs: ['1200mAh', '2.5W Mag Wireless Powerbank'],
    image: [juice],
  },
];

export default powerbankData;
